module.exports = __webpack_public_path__ + "img/tag_blue_pin.3e4d42d9.svg";